// extracted by mini-css-extract-plugin
export default {"spinner__div":"styles_spinner__div__U6CUp"};